/**
 * Upload Collector API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GdxMessageDto { 
    id?: number;
    insertTs?: string;
    parsingError?: string;
    errorResolved?: boolean;
    userData?: string;
    userDataLength?: number;
    payload?: Array<number>;
    scts?: string;
    idDevice?: number;
    idDeviceFound?: boolean;
    ignoreIdDeviceNotFound?: boolean;
    sentToQueue?: boolean;
    scheduleReprocess?: boolean;
    comId?: string;
    collectorMessageType?: GdxMessageDto.CollectorMessageTypeEnum;
    relativePositionRange?: number;
    messageCount?: number;
    gpsErrorCount?: number;
    originCode?: GdxMessageDto.OriginCodeEnum;
    sender?: string;
}
export namespace GdxMessageDto {
    export const CollectorMessageTypeEnum = {
        MiscMessage: 'MISC_MESSAGE',
        Unknown: 'UNKNOWN',
        Invalid: 'INVALID',
        PositionMessage18Byte: 'POSITION_MESSAGE_18_BYTE',
        PositionMessage17Byte: 'POSITION_MESSAGE_17_BYTE',
        PositionMessage20Byte: 'POSITION_MESSAGE_20_BYTE',
        GpsPlusRemoteMessage140Byte: 'GPS_PLUS_REMOTE_MESSAGE_140_BYTE',
        VertexPlusRemoteMessage140Byte: 'VERTEX_PLUS_REMOTE_MESSAGE_140_BYTE',
        MortalityAlarm64Byte: 'MORTALITY_ALARM_64_BYTE',
        VirtualFenceAlarm64Byte: 'VIRTUAL_FENCE_ALARM_64_BYTE',
        ExternalSensorAlarm64Byte: 'EXTERNAL_SENSOR_ALARM_64_BYTE',
        ExtendedExternalSensorAlarm64Byte: 'EXTENDED_EXTERNAL_SENSOR_ALARM_64_BYTE',
        TrapAlarm64Byte: 'TRAP_ALARM_64_BYTE',
        ProximityStatus140Byte: 'PROXIMITY_STATUS_140_BYTE',
        ExtendedProximityStatus140Byte: 'EXTENDED_PROXIMITY_STATUS_140_BYTE',
        ExternalSensorStatus140Byte: 'EXTERNAL_SENSOR_STATUS_140_BYTE',
        ExtendedExternalSensorStatus140Byte: 'EXTENDED_EXTERNAL_SENSOR_STATUS_140_BYTE',
        DosimeterMessage140Byte: 'DOSIMETER_MESSAGE_140_BYTE',
        GlobalstarMortality: 'GLOBALSTAR_MORTALITY',
        GlobalstarShortPosition: 'GLOBALSTAR_SHORT_POSITION',
        GlobalstarLongPosition: 'GLOBALSTAR_LONG_POSITION',
        GlobalstarTrapTransmitter35: 'GLOBALSTAR_TRAP_TRANSMITTER_3_5',
        GlobalstarTrapTransmitter4: 'GLOBALSTAR_TRAP_TRANSMITTER_4',
        GlobalstarLegacyMessage: 'GLOBALSTAR_LEGACY_MESSAGE',
        CompactPositionMessageV1Solex: 'COMPACT_POSITION_MESSAGE_V1_SOLEX',
        CoapActivityMessage: 'COAP_ACTIVITY_MESSAGE',
        CoapConnectionMessage: 'COAP_CONNECTION_MESSAGE',
        PartOfConcatenatedSms: 'PART_OF_CONCATENATED_SMS',
        Gdx: 'GDX',
        CoapRemoteCommandAcknowledge: 'COAP_REMOTE_COMMAND_ACKNOWLEDGE',
        ShortHeaderCompactPositionV2: 'SHORT_HEADER_COMPACT_POSITION_V2',
        ShortHeaderMessage: 'SHORT_HEADER_MESSAGE',
        ShortHeaderRemoteCommand: 'SHORT_HEADER_REMOTE_COMMAND',
        ShortHeaderRemoteCommandAcknowledge: 'SHORT_HEADER_REMOTE_COMMAND_ACKNOWLEDGE',
        ShortHeaderConfigDataStatus: 'SHORT_HEADER_CONFIG_DATA_STATUS',
        HttpUpload: 'HTTP_UPLOAD',
        CompactPositionMessageV1Lite: 'COMPACT_POSITION_MESSAGE_V1_LITE'
    } as const;
    export type CollectorMessageTypeEnum = typeof CollectorMessageTypeEnum[keyof typeof CollectorMessageTypeEnum];
    export const OriginCodeEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeEnum = typeof OriginCodeEnum[keyof typeof OriginCodeEnum];
}


export type CollectorMessageTypeEnum = typeof GdxMessageDto.CollectorMessageTypeEnum[keyof typeof GdxMessageDto.CollectorMessageTypeEnum];
